import Footer from '@fragments/Setting/Footer';
import Header from '@fragments/Setting/Header';
import { useCameraSession } from '@hooks/utils/useCameraSession';
import { useEffect, type FC } from 'react';
import Content from './Content';
import { Container } from './style';

const InterviewerSettingPage: FC = () => {
  const { saveCameraState } = useCameraSession();

  useEffect(() => {
    saveCameraState('on');
  }, []);

  return (
    <Container>
      <Header />
      <Content />
      <Footer />
    </Container>
  );
};

export default InterviewerSettingPage;
